import React, { useEffect } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import Icon from 'src/components/Icon/Icon';
import Accordion from 'src/components/Accordion/Accordion';
import Coupon from './Coupon';
import { RootState } from 'src/configs/store';

interface ResponseProps {
  title?: string,
  info?: string,
  // eslint-disable-next-line no-unused-vars
  back?: (e : any) => void,
  breadCrumb?: Function,
}

function ResponsePage({ back, breadCrumb, title, info } :ResponseProps) {
  const dispatch = useDispatch();
  const { omr:{ data } } = useSelector((state: RootState) => state.peripherals);
  const { t } = useTranslation();
  const col = data?.matrix ? new Array((Math.ceil(data?.matrix.columns / 10)+1)).fill([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]).flat() : [];

  useEffect(() => {
    return (() => dispatch.peripherals.resetCoupon());
  }, []);

  const renderInfoCard = (name) => {
    return (
      <Accordion
        title={ t(`omr.${ name }`)  }
        defaultOpen={ false }
      >
        <div>
          {
            _.map(data?.[name], (value, key) => {
              return (
                <div className="omr__read-info" key={ key }>
                  <div><pre>{  `${ key } ${ JSON.stringify(value, null, 2) } ` }</pre></div>
                </div>
              );
            })
          }
        </div>
      </Accordion>
    );
  };

  return (
    <>
      <div
        className={
          classNames({
            'omr__back': true
          })
        }
        onClick={ back }
      >
        <Icon icon="arrow" className="detail-header__arrow" />
        <span>{ breadCrumb }</span>
      </div>
      <div className="omr__response-title">
        { title }
      </div>
      <div>
        {
          !_.isEmpty(data.matrix?.matrix) && (
            <Accordion
              title={ t('omr.coupon')  }
              defaultOpen={ false }
            >
              <Coupon matrix={ data.matrix } />
            </Accordion>
          )
        }
      </div>
      {
        !_.isEmpty(data?.status) && (
          <Accordion
            title={ t('omr.status')  }
            defaultOpen={ true }
          >
            <div>
              {
                _.map(data?.status, (value, key) => {
                  return (
                    <div className="omr__read-info" key={ key }>
                      <div><pre>{  `${ key }: ${ JSON.stringify(value, null, 2) } ` }</pre></div>
                    </div>
                  );
                })
              }
            </div>
          </Accordion>
        )
      }
      {
        !_.isEmpty(data?.config) && (
          <Accordion
            title={ t('omr.status')  }
            defaultOpen={ true }
          >
            <div>
              {
                _.map(data?.config, (value, key) => {
                  return (
                    <div className="omr__read-info" key={ key }>
                      <div><pre>{  `${ key }: ${ JSON.stringify(value, null, 2) } ` }</pre></div>
                    </div>
                  );
                })
              }
            </div>
          </Accordion>
        )
      }
      { _.isEmpty(data?.status) && !data?.infoblock && <textarea className="omr__textarea" readOnly value={ info } /> }
      {
        data?.infoblock && <div className="omr__read-test">
          {
            !_.isEmpty(data?.infoblock) && (
              <Accordion
                title={ t('omr.info')  }
                defaultOpen={ true }
              >
                {
                  _.map(data?.infoblock, (info, key) => {
                    return (
                      <div className="omr__read-info-container" key={ key }>
                        <div className={
                          classNames({
                            'omr__read-info' : true,
                            'omr__read-info--error': info.infoName !== 'INFO'
                          })
                        }
                        >
                          { `${ info.infoName } ${ info.infoCode } ${ info.infoTextFilled }` }
                        </div>
                      </div>
                    );
                  }
                  )
                }
              </Accordion>
            )
          }
          { !_.isEmpty(data?.card) && renderInfoCard('card') }
          { !_.isEmpty(data?.testView) && renderInfoCard('testView') }
          { !_.isEmpty(data?.omrBlock) && renderInfoCard('omrBlock') }
          { !_.isEmpty(data?.betFormat) && renderInfoCard('betFormat') }
          { !_.isEmpty(data?.data) && renderInfoCard('data') }
          {
            !_.isEmpty(data?.matrix.matrix) && (
              <Accordion
                title={ t('omr.matrix') }
                defaultOpen={ true }
              >
                <>
                  <div className="omr__matrix-container">
                    <div className="omr__info-container">
                      <div className="omr__read-info">
                        <div>{ `${ t('omr.serialDevice') }: ${ data?.matrix.serialDevice }` }</div>
                      </div>
                      <div className="omr__read-info">
                        <div>{ `${ t('omr.cardId') }: ${ data?.matrix.cardId }` }</div>
                      </div>
                      <div className="omr__read-info">
                        <div>{ `${ t('omr.colums') }: ${ data?.matrix.columns }` }</div>
                      </div>
                      <div className="omr__read-info">
                        <div>{ `${ t('omr.cardName') }: ${ data?.matrix.cardName }` }</div>
                      </div>
                    </div>
                  </div>
                  {
                    !_.isEmpty(data?.matrix.matrix) &&
                  <div className="omr__matrix">
                    {
                      _.map(data?.matrix.matrix, (line, index) => {
                        return (
                          <div className="omr__matrix-line" key={ index }>
                            <div className="omr__line-number">{ index + 1 }: </div> <span>{ line }</span>
                          </div>
                        );
                      })
                    }
                    <div className="omr__matrix-line">
                      <div className="omr__line-number">
                      </div>
                      {
                        _.map(col, (c, index) => {
                          return (
                            <div key={ index }>{ c }</div>
                          );

                        })

                      }
                    </div>
                    <div className="omr__matrix-line omr__matrix-line--no-spacing">
                      <div className="omr__line-number">
                      </div>
                      {
                        _.map(col, (c, index) => {
                          if (+c +1 % 10 === 1 && +index !== 0){
                            return (
                              <div key={ index } className="omr__column-index">{ +index + 1 }</div>
                            );
                          } else {
                            return <div className="omr__empty-char" key={ index }>0</div>;
                          }
                        })

                      }
                    </div>
                  </div>
                  }
                </>
              </Accordion>
            )
          }
        </div>
      }
    </>
  );
}

export default ResponsePage;
